import Failure from '../../../core/Failure';
import { AccountType } from '@leedpulse-monorepo/enums';
import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';
import { ICompany, ISubscription } from '@leedpulse-monorepo/interfaces';

interface BaseUserPayload {
  email: string;
  firstname: string;
  lastname: string;
  phone: string;
  id_plan?: string; // Only required for COMPANY type (signup flow); for USER type, plan is handled via Stripe flow
  type: AccountType;
  intro: string;
}
interface CreateCompanyUserPayload extends BaseUserPayload {
  name: string;
  siret: string;
  domain: string;
  type: AccountType.COMPANY;
  sender: string;
  activation_code: string;
}

interface CreateSimpleUserPayload extends BaseUserPayload {
  linked_company_id: string;
  type: AccountType.USER;
  numberAssignment?: 'existing' | 'new' | 'none'; // Frontend-only, not used by backend
  selectedNumber?: string; // Frontend-only, used for assignUserToSubscription call
  skip_welcome_email?: boolean; // The credentials leave with the line assignment instead
}

type CreateUserPayload = CreateCompanyUserPayload | CreateSimpleUserPayload;

interface CreateUserResponse {
  success: boolean;
  data?: {
    uid: string;
    company?: ICompany;
    subscription?: ISubscription;
  };
  error?: string;
} 

async function createUser(
  payload: CreateUserPayload,
  auth?: Authentication
): Promise<CreateUserResponse> {
  try {
    if (payload.type === AccountType.USER && !auth) throw new CreateUserFailure('Authentication is required');

    const response = await HttpClient.post('/leedflow/user', payload, auth?.token || '', false, auth?.email ? {
      'x-creator-email': auth.email,
    } : undefined);

    return response;
  } catch (e) {
    console.error('error: ', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new CreateUserFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new CreateUserFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class CreateUserFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createUser;
